/**
 * Entry point for the public front end
 *
 * Do not write javascript directly into this file.
 * Please register your modules in `./lifecycles/index.js`
 */
import "./../css/sass/styles.scss";
import { documentReady} from "./utility/utils";
import {MainLifecycleManager, EVENTS} from "./lifecycles";

import "./components/animation";
import "./components/table-of-contents";
import "./components/engagement-options";
import 'media-chrome';
import 'vimeo-video-element';

////////// Add any petite vue stuff here
import { createApp } from "petite-vue";
import { accordion } from "./components/accordion";

createApp({
  accordion,
}).mount();
///////////////////////////////////////

MainLifecycleManager.callEvent(EVENTS.INIT);

documentReady((event) => {
  MainLifecycleManager.callEvent(EVENTS.DOCUMENT_READY, event)
});

window.addEventListener("load", function (event) {
  MainLifecycleManager.callEvent(EVENTS.WINDOW_LOAD, event);
});

window.addEventListener('pageloaded', function(event){
  MainLifecycleManager.callEvent(EVENTS.PAGE_LOADED, event);
})
